import * as Sentry from "@sentry/nextjs";
import { useAtomValue } from "jotai";
import { useEffect } from "react";

import { accountAtom } from "shared/lib/account/atoms";

export const useSentrySetup = () => {
  const { user } = useAtomValue(accountAtom);

  useEffect(() => {
    if (!user) return;
    const scope = Sentry.getCurrentScope();
    scope.setUser({
      ...user,
    });
  }, [user]);
};
